module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_okunai@2x-31ec47b403a42d23f16ece7f6d7927fc.webp";